import request from '@/utils/request.js'


/**
 * 获取考试须知
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserCourseStatistics(params) {
    return request({
        url: '/userService/api/app/userNurse/getUserCourseStatistics',
        method: 'post',
        data: params
    })
}

/**
 * 检查用户信息（医院、科室、职称、参加工作时间）
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserNurseCheck(params) {
    return request({
        url: '/userService/api/app/userNurse/getUserNurseCheck',
        method: 'post',
        data: params
    })
}

/**
 * 检查用户是否通过某种类型的认证
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserIsAuditPass(params) {//type  1:实名认证 2:基础认证 3:职业认证
    return request({
        url: '/userService/api/app/userNurseCertificateApp/getUserIsAuditPass',
        method: 'post',
        data: params
    })
}


/**
 * 获取用户信息
 * @param params
 * @returns {AxiosPromise}
 */
export function loginHome(params) {
    return request({
        url: '/userService/api/app/userNurse/loginHome',
        method: 'post',
        data: params
    })
}

/**
 * 获取用户（护士）信息
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserNurseApp(params) {
    return request({
        url: '/userService/api/app/userNurse/getUserNurseApp',
        method: 'post',
        data: params
    })
}
